<template>
  <vue-dropzone
    :options="dropzoneOptions"
    :awss3="awss3"
    v-on:vdropzone-complete="dzComplete"
    id="dropzone"
    ref="myVueDropzone"
  ></vue-dropzone>
</template>

<script>
import api from "@/services/api"
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
import skaler from "skaler"

export default {
  name: "DropZone",
  props: ["page", "prop", "filetype", "internal"],
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      file: undefined,
      dropzoneOptions: {
        url: api.uploadURL(),
        acceptedFiles: ".png,.jpg,.jpeg,.gif",
        headers: {},
        maxFilesize: 20,
        transformFile: (file, done) => {
          if (this.prop.sizing) {
            if (this.prop.sizing == "exact") {
              if (this.prop.width && this.prop.height) {
                if (file.width <= this.prop.width && file.height <= this.prop.height) {
                  return done(file)
                }

                const ratio = Math.min(this.prop.width / file.width, this.prop.height / file.height)
                const width = Math.round(file.width * ratio)

                return skaler(file, { width }).then((resized) => done(resized))
              }

              if (this.prop.width) {
                if (file.width <= this.prop.width) {
                  return done(file)
                }

                return skaler(file, { width: this.prop.width }).then((resized) => done(resized))
              }

              if (this.prop.height) {
                if (file.height <= this.prop.height) {
                  return done(file)
                }

                return skaler(file, { height: this.prop.height }).then((resized) => done(resized))
              }
            }

            if (this.prop.sizing == "max") {
              if (this.prop.width && this.prop.height) {
                if (file.width <= this.prop.width && file.height <= this.prop.height) {
                  return done(file)
                }

                const ratio = Math.min(this.prop.width / file.width, this.prop.height / file.height)
                const width = Math.round(file.width * ratio)

                return skaler(file, { width }).then((resized) => done(resized))
              }

              if (this.prop.width) {
                if (file.width <= this.prop.width) {
                  return done(file)
                }

                const ratio = this.prop.width / file.width
                const width = Math.round(file.width * ratio)

                return skaler(file, { width }).then((resized) => done(resized))
              }

              if (this.prop.height) {
                if (file.height <= this.prop.height) {
                  return done(file)
                }

                const ratio = this.prop.height / file.height
                const height = Math.round(file.height * ratio)

                return skaler(file, { height }).then((resized) => done(resized))
              }
            }
          }

          return done(file);
        }
      },
      awss3: {
        signingURL: api.uploadURL(),
        headers: {},
        params: {},
        sendFileToServer: false,
        withCredentials: false
      }
    }
  },
  created() {
    api.headers().then((headers) => {
      this.dropzoneOptions.headers = headers
      this.awss3.params.accesstoken = headers["access-token"]
    })
    this.awss3.params.siteid = this.$store.state.customisations.site_id
    if (this.filetype) this.dropzoneOptions.acceptedFiles = this.filetype
  },
  methods: {
    dzComplete(file) {
      this.$set(this.page, this.prop.prop_name, file.s3Url + "/" + file.s3Signature.key)
      setTimeout(() => this.$refs.myVueDropzone.removeAllFiles(), 3000)
    }
  }
}
</script>
